import { render, staticRenderFns } from "./payment-plan.vue?vue&type=template&id=5fb8ca39"
import script from "./payment-plan.vue?vue&type=script&lang=js"
export * from "./payment-plan.vue?vue&type=script&lang=js"
import style0 from "./payment-plan.vue?vue&type=style&index=0&id=5fb8ca39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports